import style from "./LearningPaths.module.css";
import { useTranslation } from "react-i18next";

import Container from "@/layouts/container/Container";
import Icon from "@/ui/icon/Icon";
import Certificate from "@/ui/certificate/Certificate";

import PathCards from "@/features/paths/components/pathCards/PathCards";
import { usePageTitle } from "@/i18n/usePageTitle";

function LearningPaths() {
	const { t } = useTranslation();
	usePageTitle("seo:titles.paths");

	return (
		<>
			<div className={style.background}>
				<Container>
					<div className={style.banner}>
						<div className={style.bannerContent}>
							<div className={style.title}>
								<h2>{t("common:nav.paths")}</h2>
								<div className={style.icoHolder}>
									<Icon
										icon="fa-star-of-life"
										iconType="fa-solid"
									/>
								</div>
							</div>
							<p>{t("paths:list.intro")}</p>
						</div>
						<div className={style.other}>
							<Certificate size={20} background={true} />
							<div className={style.decoration}>
								<Icon icon="fa-scribble" />
							</div>
						</div>
					</div>
				</Container>
			</div>
			<Container>
				<PathCards />
			</Container>
		</>
	);
}

export default LearningPaths;
